const initialState = {
    teamBeingDeleted: false,
    teamBeingUpdated: null,
    teamWhereUsersAreBeingAdded: null
}

export default initialState;
